import { Module } from 'vuex';

import tool from '@/utils/tool';
import RootModuleTypes from '@/store/interface';
import SubscribeModuleTypes from '@/store/modules/middleGround/my/subscribe/interface';

const subscribeModule: Module<SubscribeModuleTypes, RootModuleTypes> = {
    namespaced: true,
    state: {

    },
    mutations: {

    },
    actions: {
        pageRssActivityCompanyList(context, searchParams) {
            return new Promise((resolve, reject) => {
                tool.post("/personalCenter/pageRssActivityCompanyList", searchParams).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        deleteRssActivity(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/personalCenter/deleteRssActivity", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        
        
    },
};

export default subscribeModule;